import { render, staticRenderFns } from "./sibcas.html?vue&type=template&id=53f63c98&"
import script from "./sibcas.js?vue&type=script&lang=js&"
export * from "./sibcas.js?vue&type=script&lang=js&"
import style0 from "./sibcas.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports